import { render, staticRenderFns } from "./Banner007BolsasPanaleras.vue?vue&type=template&id=55e22e1a"
import script from "./Banner007BolsasPanaleras.vue?vue&type=script&lang=js"
export * from "./Banner007BolsasPanaleras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports